module.exports = __webpack_public_path__ + "static/media/main16.82f5f10a.png";